import React from 'react';
import clsx from 'clsx';

const buttonKindMap: Record<string, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  link: 'btn-link',
  default: 'btn-default'
};

interface ButtonProps {
  kind?: string;
  action?: string;
  onClick?: (name?: string, action?: string, type?: HTMLButtonElement['type']) => void;
  className?: string;
  children: React.ReactNode;
  dataTestid?: string;
}

export function Button({
  disabled,
  name,
  children,
  title,
  kind = 'primary',
  type = 'button',
  className,
  onClick,
  id,
  ...rest
}: ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      id={id}
      name={name}
      type={type}
      title={title}
      disabled={disabled}
      onClick={onClick}
      className={clsx('btn', buttonKindMap[kind], 'focus:outline-none focus-visible:shadow-outline', className)}
      {...rest}
    >
      {children || title}
    </button>
  );
}
